import { render } from "./WorldsView.vue?vue&type=template&id=8226df3c&scoped=true"
import script from "./WorldsView.vue?vue&type=script&lang=js"
export * from "./WorldsView.vue?vue&type=script&lang=js"

import "./WorldsView.vue?vue&type=style&index=0&id=8226df3c&scoped=true&lang=css"

import exportComponent from "/Users/apple/Documents/Programing/sonak/sonak_2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8226df3c"]])

export default __exports__